module.exports = __webpack_public_path__ + "media/images/clickworker_com/f2a_step_2-d72cb921e52562fcca0af8b44559cf79.png";